import { Loader2 } from "lucide-react";

export const FullScreenLoader = () => (
  <div data-testid="full-screen-loader" className="min-h-screen flex items-center justify-center">
    <Loader2 className="h-8 w-8 animate-spin text-primary" />
  </div>
);
